import PlaceDetail from "./PlaceDetail.component";

export default PlaceDetail;
